import React from 'react';

import {LayerCloseHandleV2} from '@volkswagen-onehub/layer-manager';
import {StyledToolTipModal} from './styles';
import {Close, TextCustom, TextTag} from '@vw-marketing/us-components';
import {informationTextStyle, titleTextStyle} from './helpers';

interface InfoToolTipState {
  title: string;
  information: string;
  handleInternalClose: () => void;
}

export const InfoToolTipModal = (
  state: InfoToolTipState,
  close: LayerCloseHandleV2<void>,
) => {
  const {title, information, handleInternalClose} = state;

  const onHandleClose = () => {
    close && close();
    handleInternalClose && handleInternalClose();
  };

  return (
    <StyledToolTipModal>
      <div className="tooltip__close_cta" onClick={onHandleClose}>
        <Close />
      </div>
      <div className="tooltip__title">
        <TextCustom {...titleTextStyle} tag={TextTag.h2}>
          {title}
        </TextCustom>
      </div>
      <div className="tooltip__information">
        <TextCustom {...informationTextStyle} tag={TextTag.p}>
          {information}
        </TextCustom>
      </div>
    </StyledToolTipModal>
  );
};
